PegasusTemplate.HoveringMixin = Ember.Mixin.create({
  mouseEnter: function() {
    this._super();
    PegasusTemplate.stateMachine.send('hover', { view: this });
  }
});
